import styled from 'styled-components';
import { colors } from '../colors';

const Header = styled.div`
	display: inline-block;
	width: 100%;
	height: 75px;
	background: ${colors.White};
	box-shadow: 0px 2px 6px ${colors.ShadowColorTB};
	padding: 15px 16px 15px 16px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	position: relative;
	z-index: 999;
	top: 0;
	position: sticky;
	// border-bottom: 1px solid ${colors.Grey}
`;

export default Header;
